module.exports = __webpack_public_path__ + "static/ac-checklists.e36dd3b7.png";